const requireField = field => values =>
  !values[field]
    ? { [field]: `errors.${field.toLowerCase()}_is_required` }
    : {};
const noValidation = () => ({});

const requireSubTypeField = field => values => {
  return values.Type === 'smartCabinet' &&
    (!values[field] || values[field] === 'None')
    ? { [field]: `errors.${field.toLowerCase()}_is_required` }
    : {};
};

export const validateReprovisionMode = requireField('ReprovisionMode');
export const validateType = requireField('Type');
export const validateSubType = requireSubTypeField('SubType');
export const validateName = requireField('Name');
export const validateId = requireField('Id');
export const validateDescription = noValidation;
export const validateTags = noValidation;
export const validateOrganization = requireField('Organization');
export const validateLocation = values => {
  const errors = {};

  if (!values['Area']) {
    errors.Area = 'errors.required';
  }
  if (!values['Country']) {
    errors.Country = 'errors.required';
  }
  if (!values['TimeZone']) {
    errors.TimeZone = 'errors.required';
  }

  return errors;
};

export const validateAdditionalPage = values => {
  /*
  // card payment is not a must, we can have only mobile payment option
  if (
    hasOptionalSetting(values['Type'], 'CARD_PAYMENT') &&
    !values['CardTerminal']
  ) {
    return { CardTerminal: `errors.cardpayment_is_required` };
  }
  */
  if (values['CardTerminal'] === 'Axis-ingenico') {
    // tpv nr example: 21000006
    if (
      typeof values['antenorTPVnr'] === 'string' &&
      values['antenorTPVnr'].length === 8
    ) {
      return {};
    }
    return { CardTerminal: `errors.tpv_is_required` };
  } else if (values['CardTerminal'] === 'wipay') {
    if (
      typeof values['wipayTerminalId'] === 'string' &&
      values['wipayTerminalId'].length >= 0
    ) {
      return {};
    }
    return { CardTerminal: `errors.terminalId_is_required` };
  }
  return {};
};

export default values => ({
  ...validateReprovisionMode(values),
  ...validateType(values),
  ...validateSubType(values),
  ...validateName(values),
  ...validateId(values),
  ...validateDescription(values),
  ...validateTags(values),
  ...validateOrganization(values),
  ...validateAdditionalPage(values),
  ...validateLocation(values),
});
